(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-ed", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-ed?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorEd",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed.html",
                        controller:
                            "LebaniegoYearContactosSectorEdController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-ed.new", {
                parent: "lebaniego-contacts-sector-ed",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-new.html",
                        controller: "LebaniegoYearContactosSectorEdNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-ed"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-ed",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-ed.edit", {
                parent: "lebaniego-contacts-sector-ed",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorEd"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-detail.html",
                        controller: "LebaniegoYearContactosSectorEdDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-ed"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorEd",
                        function ($stateParams, LebaniegoYearContactosSectorEd) {
                            return LebaniegoYearContactosSectorEd.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-ed",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();